import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, SiteUsers, UserInfo } from 'app/shared/types';
import { environment } from 'environment/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private apiUrl = environment.authApiBaseUrl;

  constructor(private http: HttpClient) {}

  public login(username: string, password: string): Observable<UserInfo> {
    return this.http.post<UserInfo>(`${this.apiUrl}/authenticate`, {
      username,
      password,
    });
  }

  public getSiteUsers(siteId: string): Observable<ApiResponse<SiteUsers>> {
    return this.http.get<ApiResponse<SiteUsers>>(`${this.apiUrl}/api/Sites/${siteId}/users`).pipe(shareReplay(1));
  }
}
